import classnames from 'classnames/bind'
import React from 'react'

import Slider from '@unlikelystudio/react-slider'

import Link, { LinkProps } from '~/components/Link'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface CategoryItemProps {
  name?: string
  link?: LinkProps
}
export interface ArticleTagsProps {
  className?: string
  items?: CategoryItemProps[]
}

function ArticleTags({ className, items }: ArticleTagsProps) {
  const textStyle = useStyle({ textPreset: 'text-paragraph' })
  return (
    <div className={cx(css.ArticleTags, className)}>
      <Slider className={css.slider}>
        {items?.map((item, index) => (
          <Link
            className={cx(css.tag, textStyle)}
            {...item?.link}
            key={`category${index}`}>
            <span>{item?.name}</span>
          </Link>
        ))}
      </Slider>
    </div>
  )
}

ArticleTags.defaultProps = {}

export default ArticleTags
